/**
 * Created with IntelliJ IDEA.
 * User: noam
 * Date: 8/28/13
 * Time: 10:10 AM
 * To change this template use File | Settings | File Templates.
 */
define(function (require) {
    "use strict";

    var BaseCollection = require("collections/BaseCollection");
    var TabModel = require("ui/tabsbar/js/models/TabModel");
    var TabCollection;

    TabCollection = BaseCollection.extend({
        model: TabModel
    });

    return TabCollection;

});